<div class="wrapper text-right" *ngIf="user" style="text-align: right;margin-top: 26px;">
  <a routerLink="/product/create" mat-raised-button color="accent">Shto Produkt</a>
</div>

<div>
    <app-product-list></app-product-list>
</div>
